export default "/_next/static/images/5c42b436695b4a6af9acfd634d8c93e3.jpg";